import { render, staticRenderFns } from "./carReport.vue?vue&type=template&id=64071577&scoped=true"
import script from "./carReport.vue?vue&type=script&lang=js"
export * from "./carReport.vue?vue&type=script&lang=js"
import style0 from "./carReport.vue?vue&type=style&index=0&id=64071577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64071577",
  null
  
)

export default component.exports